/**
 * @generated SignedSource<<d0710dddf66f8734056912364c221b65>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalGroupPermissionsSettingsAggQuery$variables = {
  containerId: string;
  isM3GroupPermsEnabled: boolean;
};
export type GoalGroupPermissionsSettingsAggQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GoalGroupPermissionsSettings">;
};
export type GoalGroupPermissionsSettingsAggQuery = {
  response: GoalGroupPermissionsSettingsAggQuery$data;
  variables: GoalGroupPermissionsSettingsAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isM3GroupPermsEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GoalGroupPermissionsSettingsAggQuery",
    "selections": [
      {
        "condition": "isM3GroupPermsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "GoalGroupPermissionsSettings"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoalGroupPermissionsSettingsAggQuery",
    "selections": [
      {
        "condition": "isM3GroupPermsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "TownsquareGroupConnection",
                "kind": "LinkedField",
                "name": "goals_groups_extension",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isDefaultGroup"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isEditable"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "userCount"
                          },
                          {
                            "concreteType": "ProductRole",
                            "kind": "LinkedField",
                            "name": "productRoles",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "role"
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareGroupAppPermission",
                            "kind": "LinkedField",
                            "name": "appPermissions",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "permission"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isPermitted"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a810c6bea5dbdfba12aa8411838a4ae8",
    "id": null,
    "metadata": {},
    "name": "GoalGroupPermissionsSettingsAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f49f3c52a370d4b169880d48a8a31a8a";

export default node;
